import Vue, { VNode } from "vue";

export default Vue.extend<{ src: string }>({
  name: "PaymentSystemLogo",
  functional: true,
  props: {
    src: { type: String, required: true },
  },
  render(h, ctx): VNode | VNode[] {
    return h(
      "div",
      {
        staticClass: ctx.data.staticClass,
        class: { "d-center __wrap px-2 py-1": true, ...ctx.data.class },
        directives: ctx.data.directives,
      },
      [
        h("img", {
          class: "ma-1",
          attrs: { src: ctx.props.src, alt: "systems.png" },
          staticStyle: {
            maxWidth: "100%",
          },
        }),
      ]
    );
  },
});
